(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nv-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nv-picture-gallery')) {
    customElements.define('nv-picture-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.track = this.querySelector('.nv-picture-track');
        this.slides = [...this.querySelectorAll('.nv-picture-slide')];
        this.dots = [...this.querySelectorAll('[data-gallery-index]')];
        const controls = this.querySelector('.nv-picture-controls');
        if (controls) controls.hidden = false;
        this.index = 0;
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-gallery-step], [data-gallery-index]');
          if (!button) return;
          this.go(button.hasAttribute('data-gallery-index') ? Number(button.dataset.galleryIndex) : this.index + Number(button.dataset.galleryStep));
        });
        this.track.addEventListener('keydown', event => {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
          }
        });
        this.track.addEventListener('scroll', () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            if (!this.track.clientWidth) return;
            this.index = Math.round(this.track.scrollLeft / this.track.clientWidth);
            this.update();
          });
        }, { passive: true });
        this.update();
      }
      go(index) {
        this.index = (index + this.slides.length) % this.slides.length;
        this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        this.update();
      }
      update() {
        this.dots.forEach((dot, index) => {
          if (index === this.index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }
      disconnectedCallback() { if (this.frame) cancelAnimationFrame(this.frame); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nv-sticky-buy"] && !Shopify.designMode) return;
  try {
    class NovellaStickyBuy extends HTMLElement {
    connectedCallback(){this.form=document.getElementById(this.dataset.formId);if(!this.form)return;this.observer=new IntersectionObserver(entries=>{const entry=entries[0];this.hidden=entry.isIntersecting||entry.boundingClientRect.top>0;});this.observer.observe(this.form);}
    disconnectedCallback(){this.observer?.disconnect();}
  }
  if(!customElements.get('nv-sticky-buy'))customElements.define('nv-sticky-buy',NovellaStickyBuy);
  } catch(e) { console.error(e); }
})();

})();
